module.exports = __webpack_public_path__ + "static/media/snow_specification.d3cebfbd.md";